import classNames from 'classnames'
import { TextField } from 'formik-mui'
import DeleteIcon from 'mdi-react/DeleteIcon'
import React from 'react'
import { MaterialFormikErrorMessage } from 'scenes/Dashboard/components/Inputs/MaterialFormikErrorMessage.component'
import { AutoCompleteDataType, AutoCompleteFormik } from 'scenes/Dashboard/components/Inputs/Select'
import { connect, FastField, FormProps, getIn } from 'utils-next/forms'
import * as Yup from 'yup'

import { Checkbox, FormControlLabel, IconButton, Paper } from '@mui/material'
import { withStyles, WithStyles } from '@mui/styles'

import { PositionFormValues } from '../../PersonForm.model'
import styles from './InlineForm.style'

class PositionForm extends React.PureComponent<PositionFormFullProps, PositionFormState> {
  constructor(props: PositionFormFullProps) {
    super(props)

    // TODO: Create a edition mode
    this.state = {
      isInEditMode: true,
    }

    this.handleDelete = this.handleDelete.bind(this)
    this.handleCheckbox = this.handleCheckbox.bind(this)
    this.handleCreateCompany = this.handleCreateCompany.bind(this)
  }

  handleDelete() {
    const { position, onDelete, index } = this.props
    onDelete(position, index)
  }

  handleCreateCompany(inputValue: string) {
    return {
      value: { name: inputValue, domain: 'temp' },
      display: { label: inputValue },
    }
  }

  handleCheckbox() {
    const { name, formik, position, index } = this.props
    if (!position.isCurrent) {
      formik.setFieldValue(`${name}.endedOn`, '')
    } else {
      if (formik.initialValues.roles[index]) {
        formik.setFieldValue(`${name}.endedOn`, formik.initialValues.roles[index].endedOn)
      } else {
        formik.setFieldValue(`${name}.endedOn`, '')
      }
    }
    formik.setFieldValue(`${name}.isCurrent`, !position.isCurrent)
  }

  render() {
    const { classes, className, name, position, formik } = this.props
    const companyValue = getIn(formik.values, `${name}.organization`)

    return (
      <Paper elevation={2} className={classNames(classes.formContainer, className)}>
        <div className={classes.fieldList}>
          <div className={classes.field}>
            <AutoCompleteFormik
              label="Company"
              name={`${name}.organization`}
              dataType={AutoCompleteDataType.company}
              onCreateOption={this.handleCreateCompany}
              isValidNewOption={(inputValue: string) => !!inputValue}
              autoFocus={!companyValue}
            />
            <MaterialFormikErrorMessage name={`${name}.organization`} />
          </div>
          <FastField
            component={TextField}
            label="Title"
            name={`${name}.title`}
            className={classes.field}
            required
            fullWidth
          />
          <FastField
            component={TextField}
            label="Description"
            name={`${name}.description`}
            className={classes.field}
            fullWidth
          />
          <div className={classes.dateWrapper}>
            <FastField
              component={TextField}
              label="Started on"
              name={`${name}.startedOn`}
              type="date"
              className={classes.field}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
            />
            {!position.isCurrent && (
              <FastField
                component={TextField}
                label="Ended on"
                name={`${name}.endedOn`}
                type="date"
                className={classes.field}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
              />
            )}
          </div>
          <FormControlLabel
            control={<Checkbox checked={position.isCurrent} onChange={this.handleCheckbox} color="primary" />}
            label="Is current"
          />
          <div className={classes.actions}>
            <IconButton aria-label="Delete position" onClick={this.handleDelete}>
              <DeleteIcon />
            </IconButton>
          </div>
        </div>
      </Paper>
    )
  }
}

export const positionValidationSchema = Yup.object().shape({
  organization: Yup.object()
    .shape({
      value: Yup.mixed(),
      display: Yup.mixed(),
    })
    .required('Organization is required')
    .typeError('Organization is required'),
  title: Yup.string().required('Variable title is required'),
  description: Yup.string(),
  // startedOn: Yup.date().required('Variable startedOn is required'),
  isCurrent: Yup.boolean(),
})

export type PositionFormFullProps = WithStyles<typeof styles> & {
  formik: FormProps<any>
} & PositionFormProps

type PositionFormProps = {
  className?: string
  name: string
  position: PositionFormValues
  index: number
  onDelete: (position: PositionFormValues, index: number) => void
}

type PositionFormState = {
  isInEditMode: boolean
}

export default withStyles(styles)(connect<PositionFormProps>(PositionForm as any))
